var mch365 = mch365 || {};
( function () {
    'use strict';
    jQuery( function () {
        mch365.init();
    } );
    mch365.init = function () {
        mch365.admin.init();
        mch365.booth.init();
    };
}() );